import React, { useState } from "react";
import { Button, Form, FormGroup, Label, Input } from "reactstrap"; // Usar Reactstrap
import { useAuth } from "./AuthContext";
import { Link, useNavigate } from "react-router-dom"; // Para redirigir
import Swal from "sweetalert2"; // Para notificaciones

// Usaremos validación manual simple por ahora
const RegisterForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    avatar: "", // Avatar es opcional según la DB schema
  });
  const [loading, setLoading] = useState(false); // Estado de carga del formulario
  const { register } = useAuth();
  const navigate = useNavigate(); // Podemos redirigir tras registro si queremos

  const { name, email, password, avatar } = formData;

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Iniciar carga

    // Validación básica
    if (!name || !email || !password) {
      Swal.fire(
        "Error",
        "Por favor, rellena todos los campos obligatorios (Nombre, Email, Contraseña)",
        "error"
      );
      setLoading(false);
      return;
    }

    const result = await register(formData); // Llamar a la función register del contexto

    setLoading(false); // Finalizar carga

    if (result.success) {
      // Puedes redirigir al login después de un registro exitoso
      // navigate('/login');
      // O simplemente quedarse aquí y mostrar el mensaje de éxito (el AuthProvider ya lo hace)
    }
    // El AuthProvider ya maneja las notificaciones de error
  };

  return (
    <Form onSubmit={onSubmit}>
      <FormGroup>
        <Label for="name">Nombre</Label>
        <Input
          type="text"
          name="name"
          id="name"
          placeholder="Tu nombre"
          value={name}
          onChange={onChange}
          required // Validación HTML5 básica
        />
      </FormGroup>
      <FormGroup>
        <Label for="email">Email</Label>
        <Input
          type="email"
          name="email"
          id="email"
          placeholder="Introduce tu email"
          value={email}
          onChange={onChange}
          required // Validación HTML5 básica
        />
      </FormGroup>
      <FormGroup>
        <Label for="password">Contraseña</Label>
        <Input
          type="password"
          name="password"
          id="password"
          placeholder="Crea una contraseña"
          value={password}
          onChange={onChange}
          required // Validación HTML5 básica
        />
      </FormGroup>
      <FormGroup>
        <Label for="avatar">URL Avatar (Opcional)</Label>
        <Input
          type="text" // O "url" si quieres validación de formato de URL
          name="avatar"
          id="avatar"
          placeholder="URL de tu imagen de avatar"
          value={avatar}
          onChange={onChange}
        />
      </FormGroup>
      <Button color="primary" type="submit" block disabled={loading}>
        {loading ? "Registrando..." : "Registrarse"}
      </Button>

    </Form>
  );
};

export default RegisterForm;
